/**
 * Numeric range covered by a layer legend ({ lo, hi } from its first and last labels),
 * or null when the labels aren't numbers (e.g. natural colour layers).
 */
export function legendNumericRange(legend) {
	if (!legend || legend.length < 2) return null
	const lo = parseFloat(legend[0].label)
	const hi = parseFloat(legend[legend.length - 1].label)
	if (!Number.isFinite(lo) || !Number.isFinite(hi) || lo === hi) return null
	return { lo, hi }
}

/** Legend with its labels remapped onto a custom { min, max } palette range. */
export function rescaleLegend(legend, range) {
	const legendRange = legendNumericRange(legend)
	if (!range || !legendRange) return legend

	const { lo, hi } = legendRange
	const scale = (range.max - range.min) / (hi - lo)
	return legend.map((item) => {
		const value = parseFloat(item.label)
		if (!Number.isFinite(value)) return item
		return { ...item, label: (range.min + (value - lo) * scale).toFixed(2) }
	})
}

/** Slider bounds for adjusting a legend: its range widened by one span on each side. */
export function paletteSliderBounds(legend) {
	const legendRange = legendNumericRange(legend)
	if (!legendRange) return null

	const lo = Math.min(legendRange.lo, legendRange.hi)
	const hi = Math.max(legendRange.lo, legendRange.hi)
	const span = hi - lo
	let min = lo - span
	let max = hi + span
	// Normalized indices can't leave [-1, 1]
	if (lo >= -1 && hi <= 1) {
		min = Math.max(-1, min)
		max = Math.min(1, max)
	}
	return { min: Math.round(min * 100) / 100, max: Math.round(max * 100) / 100 }
}
